import {loginContainer, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {baseDocumentLinkParams} from 'src/js/lib/raw_rendering/base_document_link_params';

import styles from './DocumentLink.less';
import {DocumentLinkProps} from '../file_types';

type OwnProps = DocumentLinkProps;

type Props = OwnProps;

const DocumentLinkComponent: React.FC<Props> = (props) => {
  const {
    children,
    suppressPadding = false,
    titleText = '',
    hrefTo,
    isAllowed,
  } = baseDocumentLinkParams(
    props,
    {},
    utils.componentUtils.getDisplayName(DocumentLinkComponent)
  );
  return (
    <span
      className={classNames(styles.dlDocumentLink, {
        [styles.dlDocumentLinkLayout]: !suppressPadding,
      })}
    >
      {isAllowed ? (
        <Link title={titleText} tabIndex={0} to={hrefTo}>
          {children}
        </Link>
      ) : (
        children
      )}
    </span>
  );
};

DocumentLinkComponent.displayName = 'DocumentLink';

export const DocumentLink = DocumentLinkComponent;
